import { ByzzerSelectOption } from "@byzzer/ui-components";

export type OpportunityRunConfig = {
    categories?: string[];
    brands?: string[];
    ppgId?: number | undefined;
    markets?: string[];
    marketTypes?: string;
};

export const OpportunityTypeMenuItems: ByzzerSelectOption[] = [
    {
        display: 'Promotion',
        value: 'promotion',
    },
    {
        display: 'Pricing',
        value: 'pricing',
    },
    {
        display: 'Assortment',
        value: 'assortment',
    },
    {
        display: 'New Products',
        value: 'product',
    },
];
